import { RouteRecordRaw } from 'vue-router';
import {
  TrainingContentsTabPage,
  TrainingListTabPage,
  TrainingMatrixTabPage,
  TrainingPage,
} from '@/pages/training';
import { usePermissionStore } from '@/entities/Permission';

export const routeName = 'Treinamentos';

const listPermissions = [{ action: 'read', subject: 'Training' }];
const matrixPermissions = [{ action: 'readMatrix', subject: 'Training' }];

function resolveFirstAccessibleTab() {
  const store = usePermissionStore();

  if (store.can('read', 'Training')) return { name: 'TreinamentosListaTreinamentos' };
  if (store.can('readMatrix', 'Training')) return { name: 'TreinamentosMatrizTreinamentos' };

  return { name: 'TreinamentosConteudos' };
}

export const route: RouteRecordRaw = {
  path: 'treinamentos',
  name: routeName,
  component: TrainingPage,
  redirect: resolveFirstAccessibleTab,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Treinamentos',
  },
  children: [
    {
      path: 'lista-treinamentos',
      name: 'TreinamentosListaTreinamentos',
      component: TrainingListTabPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Lista de Treinamentos',
        permissions: listPermissions,
      },
    },
    {
      path: 'matriz-treinamentos',
      name: 'TreinamentosMatrizTreinamentos',
      component: TrainingMatrixTabPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Matriz de Treinamentos',
        permissions: matrixPermissions,
      },
    },
    {
      path: 'conteudos',
      name: 'TreinamentosConteudos',
      component: TrainingContentsTabPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Conteúdos',
      },
    },
  ],
};
